import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type SidebarMode = 'expanded' | 'compact' | 'hidden';
const ORDER: SidebarMode[] = ['expanded', 'compact', 'hidden'];

type State = {
  mode: SidebarMode;
  /** No modo oculto, a sidebar aparece flutuando ao encostar o mouse na borda esquerda. */
  peek: boolean;
  mobileOpen: boolean;
  setMode: (m: SidebarMode) => void;
  cycle: () => void;
  setPeek: (p: boolean) => void;
  setMobileOpen: (o: boolean) => void;
};

export const useSidebar = create<State>()(
  persist(
    (set, get) => ({
      mode: 'expanded',
      peek: false,
      mobileOpen: false,
      setMode: (mode) => set({ mode, peek: false }),
      cycle: () => set({ mode: ORDER[(ORDER.indexOf(get().mode) + 1) % ORDER.length]!, peek: false }),
      setPeek: (peek) => set({ peek }),
      setMobileOpen: (mobileOpen) => set({ mobileOpen }),
    }),
    { name: 'cw.sidebar', partialize: (s) => ({ mode: s.mode }) },
  ),
);
